function cropAndResizeToBase64(file, targetWidth, targetHeight) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const img = new Image();
      img.crossOrigin = "anonymous"; // ważne dla SVG i CORS

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        const ctx = canvas.getContext("2d");

        // Przeskalowanie obrazu zachowując proporcje
        ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
        const base64 = canvas.toDataURL("image/jpeg", 1.0);
        resolve(base64);
      };

      img.onerror = () => {
        reject("Nie można załadować obrazu");
      };

      img.src = e.target.result;
    };

    reader.onerror = () => {
      reject("Błąd odczytu pliku.");
    };

    reader.readAsDataURL(file);
  });
}

export default cropAndResizeToBase64;
